import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const SentimentSatisfiedIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  40 40" style={{ color, fontSize, ...style }} {...rest}>
      <circle cx="20.4695" cy="19.6883" r="18.5809" stroke="#14965B" strokeWidth="2" />
      <path
        d="M12.8564 17.6677L14.9848 14.8744C15.0681 14.7652 15.2341 14.7704 15.3103 14.8847L17.1656 17.6677"
        stroke="#14965B"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23.7734 17.6677L25.9018 14.8744C25.9851 14.7652 26.1511 14.7704 26.2273 14.8847L28.0826 17.6677"
        stroke="#14965B"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M26.6279 25.8314C24.6275 28.3883 19.3637 31.968 14.3115 25.8314"
        stroke="#14965B"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}
export default SentimentSatisfiedIcon
